export default "__VITE_ASSET__DigkX26q__"